// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { CSSObject } from 'styled-components';

export interface MarginProps {
  margin?: string | number;
  marginTop?: string | number;
  marginRight?: string | number;
  marginBottom?: string | number;
  marginLeft?: string | number;
}

export default ({ margin, marginTop, marginRight, marginBottom, marginLeft }: MarginProps) => {
  if (margin) {
    return { margin: typeof margin === 'number' ? `${margin}px` : margin }
  }

  const marginStyle: CSSObject = { };

  if (marginTop) {
    marginStyle.marginTop = typeof marginTop === 'number' ? `${marginTop}px` : marginTop;
  }

  if (marginRight) {
    marginStyle.marginRight = typeof marginRight === 'number' ? `${marginRight}px` : marginRight;
  }

  if (marginBottom) {
    marginStyle.marginBottom = typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom;
  }

  if (marginLeft) {
    marginStyle.marginLeft = typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft;
  }

  return marginStyle;
}
